import { Box } from '@mui/material'
import { styled } from '@mui/system'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Outlet } from 'react-router-dom'

import SectionErrorBoundary from '@/components/SectionErrorBoundary'
import { isFettesHost } from '@/lib/host'
import MarketingFooter from '@/pages/marketing/components/MarketingFooter'
import MainNavbar from './MainNavbar'
import MainSidebar from './MainSidebar'

const MainLayoutRoot = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    height: '100%'
}))

const MainLayout = ({ children }) => {
    const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false)
    const isFettes = isFettesHost()

    return (
        <MainLayoutRoot sx={{ paddingTop: isFettes ? 0 : '64px' }}>
            {!isFettes && (
                <>
                    <MainNavbar
                        onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)}
                    />
                    <MainSidebar
                        onMobileClose={() => setIsSidebarMobileOpen(false)}
                        openMobile={isSidebarMobileOpen}
                    />
                </>
            )}
            {/* No top padding: every public page opens with a full-width band, which
                should meet the navbar rather than leave a strip above it. Pages that open
                with plain content carry their own padding. */}
            <Box
                sx={{
                    // viewport-fit=cover: keep content out of the notch on a
                    // landscape iPhone.
                    pl: 'env(safe-area-inset-left, 0px)',
                    pr: 'env(safe-area-inset-right, 0px)'
                }}
            >
                <SectionErrorBoundary label="main-content">
                    {children || <Outlet />}
                </SectionErrorBoundary>
            </Box>
            {!isFettes && <MarketingFooter />}
        </MainLayoutRoot>
    )
}
MainLayout.propTypes = {
    children: PropTypes.node
}
export default MainLayout
